import config from '../../config';
import {
  DigestHighlightsSlice,
  EmailFormSlice,
  HeroSlice,
  MetadataSlice,
  SliceType,
} from '../../slices';

import type { BloodhoundDocument } from '../../content-types';

interface SliceRendererProps {
  document: BloodhoundDocument;
}

export function SliceRenderer({ document }: SliceRendererProps) {
  return (
    <>
      {document.data.body.map(slice => {
        const sliceType = slice.slice_type;

        switch (sliceType) {
          case SliceType.MetadataSlice: {
            return <MetadataSlice key={slice.id} slice={slice} />;
          }

          case SliceType.EmailFormSlice: {
            return <EmailFormSlice key={slice.id} slice={slice} />;
          }

          case SliceType.HeroSlice: {
            return <HeroSlice key={slice.id} slice={slice} />;
          }

          case SliceType.DigestHighlightsSlice: {
            return (
              <DigestHighlightsSlice
                key={slice.id}
                slice={slice}
                buildId={document.buildId}
              />
            );
          }

          default: {
            return exhaustiveCheck(sliceType);
          }
        }
      })}
    </>
  );
}

function exhaustiveCheck(sliceType: never): null {
  if (config.get('env') === 'production') {
    return null;
  }

  throw new Error(
    `The slice type: ${String(sliceType)} has not yet been implemented`
  );
}
